<template>
  <div>
    <template>
      <Poptip placement="bottom" width="600" ref="poptipModal" transfer="true">
        <p class="p">{{ text }}</p>
        <template #content>
          <div class="modal_content">
            <div class="unitPrice">
              选择核算科室：
              <el-cascader
                style="width: 100%"
                placeholder="请选择或搜索"
                v-model="checkDeskId"
                :options="list"
                @change="Onchange"
                filterable
                clearable
              ></el-cascader>
            </div>
            <div class="modal_content_btn">
              <Button
                type="primary"
                class="modal_content_btn_ok"
                @click="onModalSubmit"
                >确定</Button
              >
            </div>
          </div>
        </template>
      </Poptip>
    </template>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  props: ["text", "item", "type", "list"],
  data() {
    return {
      // List: [],
      requisitiontext: "",
      checkDeskId: "",
    };
  },
  created() {
    this.checkDeskId = this.item.checkDeskId;
    // this.getCheckDeskList();
  },
  methods: {
    // async getCheckDeskList() {
    //   let d = {};
    //   let res = await $utils.api.load("admin/system/check/list", d, "get");
    //   if (res.code == 200) {
    //     let data = res.rows;
    //     let dropList = [];
    //     if (data && data.length > 0) {
    //       dropList = data.map((item) => ({
    //         value: item.id,
    //         label: item.checkDeskName,
    //         disabled: !item.children || item.children.length === 0,
    //         children: (item.children || []).map((child) => ({
    //           value: child.id,
    //           label: child.checkDeskName,
    //         })),
    //       }));
    //     }
    //     this.List = dropList;
    //   }
    // },
    Onchange(value) {
      let id = value[1];
      this.list.forEach((item) => {
        let arr = item.children;
        arr.forEach((d) => {
          if (id == d.value) {
            this.requisitiontext = d.label;
            this.item.checkDeskId = d.value;
            this.item.checkDeskName = d.label;
            this.checkDeskId = d.value;
          }
        });
      });
    },
    async onModalSubmit() {
      if (!this.requisitiontext) {
        $utils.toast.success("请选择核算科室！");
        return;
      }
      const q = this.item;
      if (this.type === 2 && this.item.deliveryTime) {
        q.deliveryTime = dayjs(this.item.deliveryTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      const endpoints = {
        1: "/admin/system/facility",
        2: "/admin/system/receive",
      };
      const endpoint = endpoints[this.type];
      if (endpoint) {
        const res = await $utils.api.load(endpoint, q, "put");
        if (res.code == 200) {
          this.$refs.poptipModal.handleClose();
          $utils.toast.success("修改成功！");
          this.$emit("reset");
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal_content {
  padding: 20px;

  .unitPrice {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 20px;
  }

  .modal_content_btn {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
p {
  width: 100px;
  height: 30px;
}
</style>
